import React, { Component } from "react";
import { getUserInfo } from "../../services/api";

class MobileOverview extends Component {
  render() {
    const userInfo = getUserInfo();
    if (!userInfo) return null;

    let { user_metadata: metadata } = userInfo;
    metadata = metadata || {};
    let firstname =
      metadata.customFirstname ||
      userInfo.username ||
      userInfo.given_name ||
      userInfo.nickname ||
      "";
    firstname = firstname.split(" ")[0];
    const email = metadata.customEmail || userInfo.email;
    const { history } = this.props;

    const goToEdit = () => history.push("/account?screen=edit");
    const goToDelete = () => history.push("/account?screen=delete");

    return (
      <div id="account-menu-container">
        <div className="one column row links overview">
          <div className="left aligned column overview" onClick={goToEdit}>
            <span className="header-title">First name</span>
            <p>{firstname}</p>
          </div>
          <div className="left aligned column overview" onClick={goToEdit}>
            <span className="header-title">Email</span>
            <p>{email}</p>
          </div>
        </div>
        <div className="one column row links overview-btn">
          <div className="center aligned column">
            <button className="ui fluid primary button overview" onClick={goToEdit}>
              EDIT ACCOUNT
            </button>
          </div>
          <div className="center aligned column">
            <button className="ui fluid primary button overview" onClick={goToDelete}>
              DELETE ACCOUNT
            </button>
          </div>
        </div>
        </div>
    );
  }
}

export default MobileOverview;
